import { TimesHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const SearchRecordsData = (filterObject, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const filterObjectForUrl = filterObject ? encodeURIComponent(filterObject) : 'NaN';
    filterObjectForUrl.replace('&', '%26');
    const url = `/Records/search?filters=${filterObjectForUrl}`;
    TimesHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default SearchRecordsData;